import type { ReactNode } from "react";
import { Pencil } from "lucide-react";
import { Button } from "@shared-kernel/primary/shared/shadcn/ui/button";

interface RecapSectionProps {
  title: string;
  onEdit: () => void;
  children: ReactNode;
}

export const RecapSection = ({ title, onEdit, children }: RecapSectionProps) => (
  <section className="rounded-md border bg-card p-4">
    <div className="mb-3 flex items-center justify-between">
      <h3 className="text-sm font-semibold">{title}</h3>
      <Button type="button" variant="ghost" size="sm" onClick={onEdit} className="h-7 gap-1 px-2 text-xs">
        <Pencil className="size-3" />
        Modifier
      </Button>
    </div>
    <dl className="grid grid-cols-1 gap-x-4 gap-y-2 text-sm sm:grid-cols-[max-content_1fr]">{children}</dl>
  </section>
);

interface RecapRowProps {
  label: string;
  value: ReactNode;
}

export const RecapRow = ({ label, value }: RecapRowProps) => {
  const isEmpty = value === undefined || value === null || value === "";
  return (
    <>
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="min-w-0 break-words font-medium">{isEmpty ? "—" : value}</dd>
    </>
  );
};
